import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AgFrameworkComponent } from 'ag-grid-angular/main';
import { ICellRendererParams } from 'ag-grid-community/main';

export interface MulticellParams {
    alwaysShowTooltip: boolean;
    items: MulticellItem[];
}

export interface MulticellTooltip {
    title?: string;
    content: string;
}

export interface MulticellItem {
    displayValue: string;
    tooltips: MulticellTooltip[];
}

interface MulticellRendererParams extends ICellRendererParams {
    value: MulticellParams;
}

@Component({
    selector: 'multicell',
    template: require('./multicell-ag-renderer.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MulticellAgRendererComponent implements AgFrameworkComponent<ICellRendererParams> {
    public alwaysShowTooltip: boolean;
    public items: MulticellItem[];

    public agInit(params: MulticellRendererParams): void {
        if (params.value) {
            this.alwaysShowTooltip = params.value.alwaysShowTooltip;
            this.items = params.value.items;
        }
    }
}